// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3u0dL","addWidgetButton":"Header_addWidgetButton__xRh1n","dashboardTabs":"Header_dashboardTabs__Q4VLs","active":"Header_active__3VZA0"};